import { render, staticRenderFns } from "./OxygenationIndex.vue?vue&type=template&id=d6acbde6&scoped=true&"
import script from "./OxygenationIndex.vue?vue&type=script&lang=js&"
export * from "./OxygenationIndex.vue?vue&type=script&lang=js&"
import style0 from "./OxygenationIndex.vue?vue&type=style&index=0&id=d6acbde6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6acbde6",
  null
  
)

export default component.exports